<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="makerCheckerList"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                  @selected=""
                >
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("admin.label.ConfigureMakerChecker") }}
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("admin.label.ActionName") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Code") }}</vs-th>
                    <vs-th>{{ $t("admin.label.EntityName") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Grouping") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Selected") }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="makerChecker"
                      v-for="(makerChecker, index) in data"
                    >
                      <vs-td :data="makerChecker.actionName">{{
                        makerChecker.actionName
                      }}</vs-td>
                      <vs-td :data="makerChecker.code">{{
                        makerChecker.code
                      }}</vs-td>
                      <vs-td :data="makerChecker.entityName">{{
                        makerChecker.entityName
                      }}</vs-td>
                      <vs-td :data="makerChecker.grouping">{{
                        makerChecker.grouping
                      }}</vs-td>
                      <vs-td :data="makerChecker.selected"
                        ><vs-switch
                          v-model="makerChecker.selected"
                          @change="
                            updateFlag(makerChecker.selected, makerChecker.code)
                          "
                      /></vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
    };
  },

  components: {
    AtomSpinner,
  },
  computed: {
    ...mapState({
      makerCheckerList: (state) => state.admin.makerCheckerList,
    }),
  },
  methods: {
    async getMakerCheckerList() {
      this.loading = true;
      try {
        await this.$store.dispatch("admin/makerCheckerListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async updateFlag(selected, code) {
      const payload = { isEnabled: { canMakerChecker: selected }, code };
      try {
        await this.$store.dispatch("admin/updateMakerCheckerAction", payload);
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
  },
  mounted() {
    this.getMakerCheckerList();
  },
};
</script>
<style scoped></style>
